import { defineFcm } from '../shared/factory';

export const FCM_ENFORCE_SECURE_IDENTIFIED_STATE = defineFcm('enforce_secure_identified_state')
	.asBoolean()
	.withDefault(false)
	.toConfig();
